import { SvgIcon } from '@/components/SvgIcon';

import starFillSrc from '~/icons/star-fill.svg';

type Props = {
  rating?: number;
};

export function StarRating({ rating = 5 }: Props) {
  return (
    <div className='flex items-center' aria-label={`${rating} out of 5 stars`}>
      {Array.from({ length: rating }, (_, index) => (
        <SvgIcon
          key={index}
          src={starFillSrc}
          alt=''
          aria-hidden='true'
          className='size-6 text-error-500'
        />
      ))}
    </div>
  );
}
